module.exports = __webpack_public_path__ + "static/media/about-video.10ff3ac1.mp4";